import React from 'react';
import { Table } from 'antd';
import trans from '../../translations.json';
import { dateFormater } from '../utils';
import reducedData from '../../reducedData.json';
import { round } from '../utils';

const ageData = Object.values(reducedData.dataPositiveByAge);

const ageDict = {
  '013': '0to13',
  1417: '14to17',
  1824: '18to24',
  2564: '25to64',
  65: '65+',
};

const roundNumb = (numb) => round(numb * 100, 2) + ' %';

const tableData = ageData
  .reduce((sum, item) => {
    let dateRecord = sum.find((record) => record.DATE === item.DATE);
    //if dateRecord doesn't exist create an empty row
    if (!dateRecord) {
      sum.push({
        DATE: item.DATE,
        '013':
          item.age_category === ageDict['013']
            ? roundNumb(item.percent_positive_7d_avg)
            : undefined,
        1417:
          item.age_category === ageDict['1417']
            ? roundNumb(item.percent_positive_7d_avg)
            : undefined,
        1824:
          item.age_category === ageDict['1824']
            ? roundNumb(item.percent_positive_7d_avg)
            : undefined,
        2564:
          item.age_category === ageDict['2564']
            ? roundNumb(item.percent_positive_7d_avg)
            : undefined,
        '65+':
          item.age_category === ageDict['65+']
            ? roundNumb(item.percent_positive_7d_avg)
            : undefined,
        date: dateFormater(item.DATE),
      });
    } else {
      dateRecord[
        Object.keys(ageDict)[
          Object.values(ageDict).indexOf(item.age_category)
        ]
      ] = roundNumb(item.percent_positive_7d_avg);
    }
    return sum;
  }, [])
  .reverse();

class PositivityByAge extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: null,
    ageData: ageData,
    tableData: tableData,
  };

  // {013: "4.57 %", 1417: "4.57 %", 1824: "4.57 %", 256…}
  render() {
    const columns = [
      {
        title: trans.date[this.props.lang],
        dataIndex: 'date',
        key: 'date',
        width: '15%',
      },
      {
        title: Object.values(
          trans.testing.ageCategories[this.props.lang],
        )[0],
        dataIndex: '013',
        key: '013',
        width: '15%',
      },
      {
        title: Object.values(
          trans.testing.ageCategories[this.props.lang],
        )[1],
        dataIndex: '1417',
        key: '1417',
        width: '15%',
      },
      {
        title: Object.values(
          trans.testing.ageCategories[this.props.lang],
        )[2],
        dataIndex: '1824',
        key: '1824',
        width: '15%',
      },
      {
        title: Object.values(
          trans.testing.ageCategories[this.props.lang],
        )[3],
        dataIndex: '2564',
        key: '2564',
        width: '15%',
      },
      {
        title: Object.values(
          trans.testing.ageCategories[this.props.lang],
        )[4],
        dataIndex: '65',
        key: '65',
        width: '15%',
      },
    ];

    return (
      <Table
        pagination={{ showSizeChanger: false }}
        columns={columns}
        dataSource={this.state.tableData}
        scroll={{ x: 300 }}
      />
    );
  }
}

export default PositivityByAge;
